export type SortableValue = string | number | boolean | null | undefined;
export const naturalCompare = new Intl.Collator('en', {
  numeric: true,
  sensitivity: 'base',
  usage: 'sort',
}).compare as (a: SortableValue, b: SortableValue) => number;

export function naturalSort<T extends SortableValue>(
  collection: ReadonlyArray<T> | null | undefined,
  direction: 'asc' | 'desc' = 'asc'
): Array<T> {
  return naturalSortBy(collection, x => x, direction);
}

export function naturalSortBy<T>(
  collection: ReadonlyArray<T> | null | undefined,
  selector: (item: T) => SortableValue,
  direction: 'asc' | 'desc' = 'asc'
): Array<T> {
  const getArgs = (a: T, b: T) => {
    const values: [SortableValue, SortableValue] = [selector(a), selector(b)];
    if (direction === 'desc') {
      values.reverse();
    }
    return values;
  };
  return (collection ?? []).slice().sort((a, b) => naturalCompare(...getArgs(a, b)));
}
